import { Inject, Injectable, Injector }from '@angular/core';

import { Document360_DatasourceService } from './Document360.datasource.index';
import { Usersnap_DatasourceService } from './Usersnap.datasource.index';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Addresses_DatasourceService } from './Addresses.datasource.index';
import { BarcodeParsing_DatasourceService } from './BarcodeParsing.datasource.index';
import { BarTender_DatasourceService } from './BarTender.datasource.index';
import { Catalogs_DatasourceService } from './Catalogs.datasource.index';
import { Discussions_DatasourceService } from './Discussions.datasource.index';
import { DockAppointments_DatasourceService } from './DockAppointments.datasource.index';
import { EntityImport_DatasourceService } from './EntityImport.datasource.index';
import { Equipment_DatasourceService } from './Equipment.datasource.index';
import { ExcelInventoryImport_DatasourceService } from './ExcelInventoryImport.datasource.index';
import { ExcelLocationImport_DatasourceService } from './ExcelLocationImport.datasource.index';
import { ExcelMaterialImport_DatasourceService } from './ExcelMaterialImport.datasource.index';
import { ExcelProjectImport_DatasourceService } from './ExcelProjectImport.datasource.index';
import { Inspections_DatasourceService } from './Inspections.datasource.index';
import { InventoryTransfers_DatasourceService } from './InventoryTransfers.datasource.index';
import { LaborManagement_DatasourceService } from './LaborManagement.datasource.index';
import { LoadContainers_DatasourceService } from './LoadContainers.datasource.index';
import { Owners_DatasourceService } from './Owners.datasource.index';
import { PalletTransactions_DatasourceService } from './PalletTransactions.datasource.index';
import { PrimaryPicks_DatasourceService } from './PrimaryPicks.datasource.index';
import { Replenishments_DatasourceService } from './Replenishments.datasource.index';
import { Returns_DatasourceService } from './Returns.datasource.index';
import { Surveys_DatasourceService } from './Surveys.datasource.index';
import { TemperatureReadings_DatasourceService } from './TemperatureReadings.datasource.index';
import { TransloadOrders_DatasourceService } from './TransloadOrders.datasource.index';
import { WarehouseTransfers_DatasourceService } from './WarehouseTransfers.datasource.index';
import { Waves_DatasourceService } from './Waves.datasource.index';
import { Instructions_DatasourceService } from './Instructions.datasource.index';
import { WorkOrders_DatasourceService } from './WorkOrders.datasource.index';
import { InventoryCounts_DatasourceService } from './InventoryCounts.datasource.index';
import { ShippingContainers_DatasourceService } from './ShippingContainers.datasource.index';
import { Materials_DatasourceService } from './Materials.datasource.index';
import { Carriers_DatasourceService } from './Carriers.datasource.index';
import { Locations_DatasourceService } from './Locations.datasource.index';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { Allocations_DatasourceService } from './Allocations.datasource.index';
import { PrintNode_DatasourceService } from './PrintNode.datasource.index';
import { SerialNumbers_DatasourceService } from './SerialNumbers.datasource.index';
import { Lots_DatasourceService } from './Lots.datasource.index';
import { Inventory_DatasourceService } from './Inventory.datasource.index';
import { AsnOrders_DatasourceService } from './AsnOrders.datasource.index';
import { ExcelOrderImport_DatasourceService } from './ExcelOrderImport.datasource.index';
import { Attachments_DatasourceService } from './Attachments.datasource.index';
import { Cartonization_DatasourceService } from './Cartonization.datasource.index';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { InventoryTransformations_DatasourceService } from './InventoryTransformations.datasource.index';
import { Manifesting_DatasourceService } from './Manifesting.datasource.index';
import { PackVerification_DatasourceService } from './PackVerification.datasource.index';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { Manufacturing_DatasourceService } from './Manufacturing.datasource.index';

import { FootprintManager_allocation_configurations_grid___ds_allocation_configurations_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_activity_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_entity_user_defined_field_values_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_field_selector_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_footprint_events_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_footprint_events_statuses_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_footprint_events_type_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_integration_info_by_order_idService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_order_by_order_idService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_order_class_by_orderClassIdService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_order_transmissions_by_order_idService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_planService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_plansService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_reason_code_by_idService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_status_count_licenseplatesService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_status_count_locationsService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_status_count_lotService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_status_count_materialsService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_status_count_orderclassService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_status_count_serialsService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_task_detailsService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_warehouse_viz_modelService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_get_wavelength_transmission_typeService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_inbound_orders_details_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_inbound_orders_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_invoice_types_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_catalogs_by_project_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_catalogs_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_components_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_kit_editorService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_kits_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_substitutions_editorService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_material_substitutions_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_operation_types_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_orderclasses_inbound_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_payment_term_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_print_order_labels_options_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_reason_code_parent_entities_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_reason_codes_ddService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_reason_codes_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_return_serial_numbers_selector_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_sales_order_line_components_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_sales_order_line_kit_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_sales_order_line_substitutions_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_scheduled_for_today_manufacturing_ordersService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_support_tests_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_transload_order_editorService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_transload_order_lines_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_transload_order_receiving_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_transload_orders_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_transload_outbound_shipments_gridService } from './FootprintManager.datasource.index';
import { FootprintManager_ds_transload_received_inventory_gridService } from './FootprintManager.datasource.index';

@Injectable({ providedIn: 'root' })
export class FootprintManager_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Document360 = this.injector.get(Document360_DatasourceService);
    this.Usersnap = this.injector.get(Usersnap_DatasourceService);
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Addresses = this.injector.get(Addresses_DatasourceService);
    this.BarcodeParsing = this.injector.get(BarcodeParsing_DatasourceService);
    this.BarTender = this.injector.get(BarTender_DatasourceService);
    this.Catalogs = this.injector.get(Catalogs_DatasourceService);
    this.Discussions = this.injector.get(Discussions_DatasourceService);
    this.DockAppointments = this.injector.get(DockAppointments_DatasourceService);
    this.EntityImport = this.injector.get(EntityImport_DatasourceService);
    this.Equipment = this.injector.get(Equipment_DatasourceService);
    this.ExcelInventoryImport = this.injector.get(ExcelInventoryImport_DatasourceService);
    this.ExcelLocationImport = this.injector.get(ExcelLocationImport_DatasourceService);
    this.ExcelMaterialImport = this.injector.get(ExcelMaterialImport_DatasourceService);
    this.ExcelProjectImport = this.injector.get(ExcelProjectImport_DatasourceService);
    this.Inspections = this.injector.get(Inspections_DatasourceService);
    this.InventoryTransfers = this.injector.get(InventoryTransfers_DatasourceService);
    this.LaborManagement = this.injector.get(LaborManagement_DatasourceService);
    this.LoadContainers = this.injector.get(LoadContainers_DatasourceService);
    this.Owners = this.injector.get(Owners_DatasourceService);
    this.PalletTransactions = this.injector.get(PalletTransactions_DatasourceService);
    this.PrimaryPicks = this.injector.get(PrimaryPicks_DatasourceService);
    this.Replenishments = this.injector.get(Replenishments_DatasourceService);
    this.Returns = this.injector.get(Returns_DatasourceService);
    this.Surveys = this.injector.get(Surveys_DatasourceService);
    this.TemperatureReadings = this.injector.get(TemperatureReadings_DatasourceService);
    this.TransloadOrders = this.injector.get(TransloadOrders_DatasourceService);
    this.WarehouseTransfers = this.injector.get(WarehouseTransfers_DatasourceService);
    this.Waves = this.injector.get(Waves_DatasourceService);
    this.Instructions = this.injector.get(Instructions_DatasourceService);
    this.WorkOrders = this.injector.get(WorkOrders_DatasourceService);
    this.InventoryCounts = this.injector.get(InventoryCounts_DatasourceService);
    this.ShippingContainers = this.injector.get(ShippingContainers_DatasourceService);
    this.Materials = this.injector.get(Materials_DatasourceService);
    this.Carriers = this.injector.get(Carriers_DatasourceService);
    this.Locations = this.injector.get(Locations_DatasourceService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_DatasourceService);
    this.Allocations = this.injector.get(Allocations_DatasourceService);
    this.PrintNode = this.injector.get(PrintNode_DatasourceService);
    this.SerialNumbers = this.injector.get(SerialNumbers_DatasourceService);
    this.Lots = this.injector.get(Lots_DatasourceService);
    this.Inventory = this.injector.get(Inventory_DatasourceService);
    this.AsnOrders = this.injector.get(AsnOrders_DatasourceService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_DatasourceService);
    this.Attachments = this.injector.get(Attachments_DatasourceService);
    this.Cartonization = this.injector.get(Cartonization_DatasourceService);
    this.Invoices = this.injector.get(Invoices_DatasourceService);
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.InventoryTransformations = this.injector.get(InventoryTransformations_DatasourceService);
    this.Manifesting = this.injector.get(Manifesting_DatasourceService);
    this.PackVerification = this.injector.get(PackVerification_DatasourceService);
    this.SalesOrders = this.injector.get(SalesOrders_DatasourceService);
    this.Manufacturing = this.injector.get(Manufacturing_DatasourceService);
  }

    public Document360: Document360_DatasourceService;
    public Usersnap: Usersnap_DatasourceService;
    public Utilities: Utilities_DatasourceService;
    public Addresses: Addresses_DatasourceService;
    public BarcodeParsing: BarcodeParsing_DatasourceService;
    public BarTender: BarTender_DatasourceService;
    public Catalogs: Catalogs_DatasourceService;
    public Discussions: Discussions_DatasourceService;
    public DockAppointments: DockAppointments_DatasourceService;
    public EntityImport: EntityImport_DatasourceService;
    public Equipment: Equipment_DatasourceService;
    public ExcelInventoryImport: ExcelInventoryImport_DatasourceService;
    public ExcelLocationImport: ExcelLocationImport_DatasourceService;
    public ExcelMaterialImport: ExcelMaterialImport_DatasourceService;
    public ExcelProjectImport: ExcelProjectImport_DatasourceService;
    public Inspections: Inspections_DatasourceService;
    public InventoryTransfers: InventoryTransfers_DatasourceService;
    public LaborManagement: LaborManagement_DatasourceService;
    public LoadContainers: LoadContainers_DatasourceService;
    public Owners: Owners_DatasourceService;
    public PalletTransactions: PalletTransactions_DatasourceService;
    public PrimaryPicks: PrimaryPicks_DatasourceService;
    public Replenishments: Replenishments_DatasourceService;
    public Returns: Returns_DatasourceService;
    public Surveys: Surveys_DatasourceService;
    public TemperatureReadings: TemperatureReadings_DatasourceService;
    public TransloadOrders: TransloadOrders_DatasourceService;
    public WarehouseTransfers: WarehouseTransfers_DatasourceService;
    public Waves: Waves_DatasourceService;
    public Instructions: Instructions_DatasourceService;
    public WorkOrders: WorkOrders_DatasourceService;
    public InventoryCounts: InventoryCounts_DatasourceService;
    public ShippingContainers: ShippingContainers_DatasourceService;
    public Materials: Materials_DatasourceService;
    public Carriers: Carriers_DatasourceService;
    public Locations: Locations_DatasourceService;
    public PurchaseOrders: PurchaseOrders_DatasourceService;
    public Allocations: Allocations_DatasourceService;
    public PrintNode: PrintNode_DatasourceService;
    public SerialNumbers: SerialNumbers_DatasourceService;
    public Lots: Lots_DatasourceService;
    public Inventory: Inventory_DatasourceService;
    public AsnOrders: AsnOrders_DatasourceService;
    public ExcelOrderImport: ExcelOrderImport_DatasourceService;
    public Attachments: Attachments_DatasourceService;
    public Cartonization: Cartonization_DatasourceService;
    public Invoices: Invoices_DatasourceService;
    public Notifications: Notifications_DatasourceService;
    public InventoryTransformations: InventoryTransformations_DatasourceService;
    public Manifesting: Manifesting_DatasourceService;
    public PackVerification: PackVerification_DatasourceService;
    public SalesOrders: SalesOrders_DatasourceService;
    public Manufacturing: Manufacturing_DatasourceService;
  public FootprintManager: FootprintManager_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _allocation_configurations_grid___ds_allocation_configurations_grid: FootprintManager_allocation_configurations_grid___ds_allocation_configurations_gridService;
  public get allocation_configurations_grid___ds_allocation_configurations_grid(): FootprintManager_allocation_configurations_grid___ds_allocation_configurations_gridService {
    if(!this._allocation_configurations_grid___ds_allocation_configurations_grid) {
      this._allocation_configurations_grid___ds_allocation_configurations_grid = this.injector.get(FootprintManager_allocation_configurations_grid___ds_allocation_configurations_gridService);
    }
    return this._allocation_configurations_grid___ds_allocation_configurations_grid;
  }
  private _ds_activity_grid: FootprintManager_ds_activity_gridService;
  public get ds_activity_grid(): FootprintManager_ds_activity_gridService {
    if(!this._ds_activity_grid) {
      this._ds_activity_grid = this.injector.get(FootprintManager_ds_activity_gridService);
    }
    return this._ds_activity_grid;
  }
  private _ds_entity_user_defined_field_values_grid: FootprintManager_ds_entity_user_defined_field_values_gridService;
  public get ds_entity_user_defined_field_values_grid(): FootprintManager_ds_entity_user_defined_field_values_gridService {
    if(!this._ds_entity_user_defined_field_values_grid) {
      this._ds_entity_user_defined_field_values_grid = this.injector.get(FootprintManager_ds_entity_user_defined_field_values_gridService);
    }
    return this._ds_entity_user_defined_field_values_grid;
  }
  private _ds_field_selector_grid: FootprintManager_ds_field_selector_gridService;
  public get ds_field_selector_grid(): FootprintManager_ds_field_selector_gridService {
    if(!this._ds_field_selector_grid) {
      this._ds_field_selector_grid = this.injector.get(FootprintManager_ds_field_selector_gridService);
    }
    return this._ds_field_selector_grid;
  }
  private _ds_footprint_events_grid: FootprintManager_ds_footprint_events_gridService;
  public get ds_footprint_events_grid(): FootprintManager_ds_footprint_events_gridService {
    if(!this._ds_footprint_events_grid) {
      this._ds_footprint_events_grid = this.injector.get(FootprintManager_ds_footprint_events_gridService);
    }
    return this._ds_footprint_events_grid;
  }
  private _ds_footprint_events_statuses_dd: FootprintManager_ds_footprint_events_statuses_ddService;
  public get ds_footprint_events_statuses_dd(): FootprintManager_ds_footprint_events_statuses_ddService {
    if(!this._ds_footprint_events_statuses_dd) {
      this._ds_footprint_events_statuses_dd = this.injector.get(FootprintManager_ds_footprint_events_statuses_ddService);
    }
    return this._ds_footprint_events_statuses_dd;
  }
  private _ds_footprint_events_type_dd: FootprintManager_ds_footprint_events_type_ddService;
  public get ds_footprint_events_type_dd(): FootprintManager_ds_footprint_events_type_ddService {
    if(!this._ds_footprint_events_type_dd) {
      this._ds_footprint_events_type_dd = this.injector.get(FootprintManager_ds_footprint_events_type_ddService);
    }
    return this._ds_footprint_events_type_dd;
  }
  private _ds_get_integration_info_by_order_id: FootprintManager_ds_get_integration_info_by_order_idService;
  public get ds_get_integration_info_by_order_id(): FootprintManager_ds_get_integration_info_by_order_idService {
    if(!this._ds_get_integration_info_by_order_id) {
      this._ds_get_integration_info_by_order_id = this.injector.get(FootprintManager_ds_get_integration_info_by_order_idService);
    }
    return this._ds_get_integration_info_by_order_id;
  }
  private _ds_get_order_by_order_id: FootprintManager_ds_get_order_by_order_idService;
  public get ds_get_order_by_order_id(): FootprintManager_ds_get_order_by_order_idService {
    if(!this._ds_get_order_by_order_id) {
      this._ds_get_order_by_order_id = this.injector.get(FootprintManager_ds_get_order_by_order_idService);
    }
    return this._ds_get_order_by_order_id;
  }
  private _ds_get_order_class_by_orderClassId: FootprintManager_ds_get_order_class_by_orderClassIdService;
  public get ds_get_order_class_by_orderClassId(): FootprintManager_ds_get_order_class_by_orderClassIdService {
    if(!this._ds_get_order_class_by_orderClassId) {
      this._ds_get_order_class_by_orderClassId = this.injector.get(FootprintManager_ds_get_order_class_by_orderClassIdService);
    }
    return this._ds_get_order_class_by_orderClassId;
  }
  private _ds_get_order_transmissions_by_order_id: FootprintManager_ds_get_order_transmissions_by_order_idService;
  public get ds_get_order_transmissions_by_order_id(): FootprintManager_ds_get_order_transmissions_by_order_idService {
    if(!this._ds_get_order_transmissions_by_order_id) {
      this._ds_get_order_transmissions_by_order_id = this.injector.get(FootprintManager_ds_get_order_transmissions_by_order_idService);
    }
    return this._ds_get_order_transmissions_by_order_id;
  }
  private _ds_get_plan: FootprintManager_ds_get_planService;
  public get ds_get_plan(): FootprintManager_ds_get_planService {
    if(!this._ds_get_plan) {
      this._ds_get_plan = this.injector.get(FootprintManager_ds_get_planService);
    }
    return this._ds_get_plan;
  }
  private _ds_get_plans: FootprintManager_ds_get_plansService;
  public get ds_get_plans(): FootprintManager_ds_get_plansService {
    if(!this._ds_get_plans) {
      this._ds_get_plans = this.injector.get(FootprintManager_ds_get_plansService);
    }
    return this._ds_get_plans;
  }
  private _ds_get_reason_code_by_id: FootprintManager_ds_get_reason_code_by_idService;
  public get ds_get_reason_code_by_id(): FootprintManager_ds_get_reason_code_by_idService {
    if(!this._ds_get_reason_code_by_id) {
      this._ds_get_reason_code_by_id = this.injector.get(FootprintManager_ds_get_reason_code_by_idService);
    }
    return this._ds_get_reason_code_by_id;
  }
  private _ds_get_status_count_licenseplates: FootprintManager_ds_get_status_count_licenseplatesService;
  public get ds_get_status_count_licenseplates(): FootprintManager_ds_get_status_count_licenseplatesService {
    if(!this._ds_get_status_count_licenseplates) {
      this._ds_get_status_count_licenseplates = this.injector.get(FootprintManager_ds_get_status_count_licenseplatesService);
    }
    return this._ds_get_status_count_licenseplates;
  }
  private _ds_get_status_count_locations: FootprintManager_ds_get_status_count_locationsService;
  public get ds_get_status_count_locations(): FootprintManager_ds_get_status_count_locationsService {
    if(!this._ds_get_status_count_locations) {
      this._ds_get_status_count_locations = this.injector.get(FootprintManager_ds_get_status_count_locationsService);
    }
    return this._ds_get_status_count_locations;
  }
  private _ds_get_status_count_lot: FootprintManager_ds_get_status_count_lotService;
  public get ds_get_status_count_lot(): FootprintManager_ds_get_status_count_lotService {
    if(!this._ds_get_status_count_lot) {
      this._ds_get_status_count_lot = this.injector.get(FootprintManager_ds_get_status_count_lotService);
    }
    return this._ds_get_status_count_lot;
  }
  private _ds_get_status_count_materials: FootprintManager_ds_get_status_count_materialsService;
  public get ds_get_status_count_materials(): FootprintManager_ds_get_status_count_materialsService {
    if(!this._ds_get_status_count_materials) {
      this._ds_get_status_count_materials = this.injector.get(FootprintManager_ds_get_status_count_materialsService);
    }
    return this._ds_get_status_count_materials;
  }
  private _ds_get_status_count_orderclass: FootprintManager_ds_get_status_count_orderclassService;
  public get ds_get_status_count_orderclass(): FootprintManager_ds_get_status_count_orderclassService {
    if(!this._ds_get_status_count_orderclass) {
      this._ds_get_status_count_orderclass = this.injector.get(FootprintManager_ds_get_status_count_orderclassService);
    }
    return this._ds_get_status_count_orderclass;
  }
  private _ds_get_status_count_serials: FootprintManager_ds_get_status_count_serialsService;
  public get ds_get_status_count_serials(): FootprintManager_ds_get_status_count_serialsService {
    if(!this._ds_get_status_count_serials) {
      this._ds_get_status_count_serials = this.injector.get(FootprintManager_ds_get_status_count_serialsService);
    }
    return this._ds_get_status_count_serials;
  }
  private _ds_get_task_details: FootprintManager_ds_get_task_detailsService;
  public get ds_get_task_details(): FootprintManager_ds_get_task_detailsService {
    if(!this._ds_get_task_details) {
      this._ds_get_task_details = this.injector.get(FootprintManager_ds_get_task_detailsService);
    }
    return this._ds_get_task_details;
  }
  private _ds_get_warehouse_viz_model: FootprintManager_ds_get_warehouse_viz_modelService;
  public get ds_get_warehouse_viz_model(): FootprintManager_ds_get_warehouse_viz_modelService {
    if(!this._ds_get_warehouse_viz_model) {
      this._ds_get_warehouse_viz_model = this.injector.get(FootprintManager_ds_get_warehouse_viz_modelService);
    }
    return this._ds_get_warehouse_viz_model;
  }
  private _ds_get_wavelength_transmission_type: FootprintManager_ds_get_wavelength_transmission_typeService;
  public get ds_get_wavelength_transmission_type(): FootprintManager_ds_get_wavelength_transmission_typeService {
    if(!this._ds_get_wavelength_transmission_type) {
      this._ds_get_wavelength_transmission_type = this.injector.get(FootprintManager_ds_get_wavelength_transmission_typeService);
    }
    return this._ds_get_wavelength_transmission_type;
  }
  private _ds_inbound_orders_details_grid: FootprintManager_ds_inbound_orders_details_gridService;
  public get ds_inbound_orders_details_grid(): FootprintManager_ds_inbound_orders_details_gridService {
    if(!this._ds_inbound_orders_details_grid) {
      this._ds_inbound_orders_details_grid = this.injector.get(FootprintManager_ds_inbound_orders_details_gridService);
    }
    return this._ds_inbound_orders_details_grid;
  }
  private _ds_inbound_orders_grid: FootprintManager_ds_inbound_orders_gridService;
  public get ds_inbound_orders_grid(): FootprintManager_ds_inbound_orders_gridService {
    if(!this._ds_inbound_orders_grid) {
      this._ds_inbound_orders_grid = this.injector.get(FootprintManager_ds_inbound_orders_gridService);
    }
    return this._ds_inbound_orders_grid;
  }
  private _ds_invoice_types_dd: FootprintManager_ds_invoice_types_ddService;
  public get ds_invoice_types_dd(): FootprintManager_ds_invoice_types_ddService {
    if(!this._ds_invoice_types_dd) {
      this._ds_invoice_types_dd = this.injector.get(FootprintManager_ds_invoice_types_ddService);
    }
    return this._ds_invoice_types_dd;
  }
  private _ds_material_catalogs_by_project_grid: FootprintManager_ds_material_catalogs_by_project_gridService;
  public get ds_material_catalogs_by_project_grid(): FootprintManager_ds_material_catalogs_by_project_gridService {
    if(!this._ds_material_catalogs_by_project_grid) {
      this._ds_material_catalogs_by_project_grid = this.injector.get(FootprintManager_ds_material_catalogs_by_project_gridService);
    }
    return this._ds_material_catalogs_by_project_grid;
  }
  private _ds_material_catalogs_grid: FootprintManager_ds_material_catalogs_gridService;
  public get ds_material_catalogs_grid(): FootprintManager_ds_material_catalogs_gridService {
    if(!this._ds_material_catalogs_grid) {
      this._ds_material_catalogs_grid = this.injector.get(FootprintManager_ds_material_catalogs_gridService);
    }
    return this._ds_material_catalogs_grid;
  }
  private _ds_material_components_grid: FootprintManager_ds_material_components_gridService;
  public get ds_material_components_grid(): FootprintManager_ds_material_components_gridService {
    if(!this._ds_material_components_grid) {
      this._ds_material_components_grid = this.injector.get(FootprintManager_ds_material_components_gridService);
    }
    return this._ds_material_components_grid;
  }
  private _ds_material_kit_editor: FootprintManager_ds_material_kit_editorService;
  public get ds_material_kit_editor(): FootprintManager_ds_material_kit_editorService {
    if(!this._ds_material_kit_editor) {
      this._ds_material_kit_editor = this.injector.get(FootprintManager_ds_material_kit_editorService);
    }
    return this._ds_material_kit_editor;
  }
  private _ds_material_kits_grid: FootprintManager_ds_material_kits_gridService;
  public get ds_material_kits_grid(): FootprintManager_ds_material_kits_gridService {
    if(!this._ds_material_kits_grid) {
      this._ds_material_kits_grid = this.injector.get(FootprintManager_ds_material_kits_gridService);
    }
    return this._ds_material_kits_grid;
  }
  private _ds_material_substitutions_editor: FootprintManager_ds_material_substitutions_editorService;
  public get ds_material_substitutions_editor(): FootprintManager_ds_material_substitutions_editorService {
    if(!this._ds_material_substitutions_editor) {
      this._ds_material_substitutions_editor = this.injector.get(FootprintManager_ds_material_substitutions_editorService);
    }
    return this._ds_material_substitutions_editor;
  }
  private _ds_material_substitutions_grid: FootprintManager_ds_material_substitutions_gridService;
  public get ds_material_substitutions_grid(): FootprintManager_ds_material_substitutions_gridService {
    if(!this._ds_material_substitutions_grid) {
      this._ds_material_substitutions_grid = this.injector.get(FootprintManager_ds_material_substitutions_gridService);
    }
    return this._ds_material_substitutions_grid;
  }
  private _ds_operation_types_dd: FootprintManager_ds_operation_types_ddService;
  public get ds_operation_types_dd(): FootprintManager_ds_operation_types_ddService {
    if(!this._ds_operation_types_dd) {
      this._ds_operation_types_dd = this.injector.get(FootprintManager_ds_operation_types_ddService);
    }
    return this._ds_operation_types_dd;
  }
  private _ds_orderclasses_inbound_dd: FootprintManager_ds_orderclasses_inbound_ddService;
  public get ds_orderclasses_inbound_dd(): FootprintManager_ds_orderclasses_inbound_ddService {
    if(!this._ds_orderclasses_inbound_dd) {
      this._ds_orderclasses_inbound_dd = this.injector.get(FootprintManager_ds_orderclasses_inbound_ddService);
    }
    return this._ds_orderclasses_inbound_dd;
  }
  private _ds_payment_term_dd: FootprintManager_ds_payment_term_ddService;
  public get ds_payment_term_dd(): FootprintManager_ds_payment_term_ddService {
    if(!this._ds_payment_term_dd) {
      this._ds_payment_term_dd = this.injector.get(FootprintManager_ds_payment_term_ddService);
    }
    return this._ds_payment_term_dd;
  }
  private _ds_print_order_labels_options_dd: FootprintManager_ds_print_order_labels_options_ddService;
  public get ds_print_order_labels_options_dd(): FootprintManager_ds_print_order_labels_options_ddService {
    if(!this._ds_print_order_labels_options_dd) {
      this._ds_print_order_labels_options_dd = this.injector.get(FootprintManager_ds_print_order_labels_options_ddService);
    }
    return this._ds_print_order_labels_options_dd;
  }
  private _ds_reason_code_parent_entities_dd: FootprintManager_ds_reason_code_parent_entities_ddService;
  public get ds_reason_code_parent_entities_dd(): FootprintManager_ds_reason_code_parent_entities_ddService {
    if(!this._ds_reason_code_parent_entities_dd) {
      this._ds_reason_code_parent_entities_dd = this.injector.get(FootprintManager_ds_reason_code_parent_entities_ddService);
    }
    return this._ds_reason_code_parent_entities_dd;
  }
  private _ds_reason_codes_dd: FootprintManager_ds_reason_codes_ddService;
  public get ds_reason_codes_dd(): FootprintManager_ds_reason_codes_ddService {
    if(!this._ds_reason_codes_dd) {
      this._ds_reason_codes_dd = this.injector.get(FootprintManager_ds_reason_codes_ddService);
    }
    return this._ds_reason_codes_dd;
  }
  private _ds_reason_codes_grid: FootprintManager_ds_reason_codes_gridService;
  public get ds_reason_codes_grid(): FootprintManager_ds_reason_codes_gridService {
    if(!this._ds_reason_codes_grid) {
      this._ds_reason_codes_grid = this.injector.get(FootprintManager_ds_reason_codes_gridService);
    }
    return this._ds_reason_codes_grid;
  }
  private _ds_return_serial_numbers_selector_grid: FootprintManager_ds_return_serial_numbers_selector_gridService;
  public get ds_return_serial_numbers_selector_grid(): FootprintManager_ds_return_serial_numbers_selector_gridService {
    if(!this._ds_return_serial_numbers_selector_grid) {
      this._ds_return_serial_numbers_selector_grid = this.injector.get(FootprintManager_ds_return_serial_numbers_selector_gridService);
    }
    return this._ds_return_serial_numbers_selector_grid;
  }
  private _ds_sales_order_line_components_grid: FootprintManager_ds_sales_order_line_components_gridService;
  public get ds_sales_order_line_components_grid(): FootprintManager_ds_sales_order_line_components_gridService {
    if(!this._ds_sales_order_line_components_grid) {
      this._ds_sales_order_line_components_grid = this.injector.get(FootprintManager_ds_sales_order_line_components_gridService);
    }
    return this._ds_sales_order_line_components_grid;
  }
  private _ds_sales_order_line_kit_grid: FootprintManager_ds_sales_order_line_kit_gridService;
  public get ds_sales_order_line_kit_grid(): FootprintManager_ds_sales_order_line_kit_gridService {
    if(!this._ds_sales_order_line_kit_grid) {
      this._ds_sales_order_line_kit_grid = this.injector.get(FootprintManager_ds_sales_order_line_kit_gridService);
    }
    return this._ds_sales_order_line_kit_grid;
  }
  private _ds_sales_order_line_substitutions_grid: FootprintManager_ds_sales_order_line_substitutions_gridService;
  public get ds_sales_order_line_substitutions_grid(): FootprintManager_ds_sales_order_line_substitutions_gridService {
    if(!this._ds_sales_order_line_substitutions_grid) {
      this._ds_sales_order_line_substitutions_grid = this.injector.get(FootprintManager_ds_sales_order_line_substitutions_gridService);
    }
    return this._ds_sales_order_line_substitutions_grid;
  }
  private _ds_scheduled_for_today_manufacturing_orders: FootprintManager_ds_scheduled_for_today_manufacturing_ordersService;
  public get ds_scheduled_for_today_manufacturing_orders(): FootprintManager_ds_scheduled_for_today_manufacturing_ordersService {
    if(!this._ds_scheduled_for_today_manufacturing_orders) {
      this._ds_scheduled_for_today_manufacturing_orders = this.injector.get(FootprintManager_ds_scheduled_for_today_manufacturing_ordersService);
    }
    return this._ds_scheduled_for_today_manufacturing_orders;
  }
  private _ds_support_tests_grid: FootprintManager_ds_support_tests_gridService;
  public get ds_support_tests_grid(): FootprintManager_ds_support_tests_gridService {
    if(!this._ds_support_tests_grid) {
      this._ds_support_tests_grid = this.injector.get(FootprintManager_ds_support_tests_gridService);
    }
    return this._ds_support_tests_grid;
  }
  private _ds_transload_order_editor: FootprintManager_ds_transload_order_editorService;
  public get ds_transload_order_editor(): FootprintManager_ds_transload_order_editorService {
    if(!this._ds_transload_order_editor) {
      this._ds_transload_order_editor = this.injector.get(FootprintManager_ds_transload_order_editorService);
    }
    return this._ds_transload_order_editor;
  }
  private _ds_transload_order_lines_grid: FootprintManager_ds_transload_order_lines_gridService;
  public get ds_transload_order_lines_grid(): FootprintManager_ds_transload_order_lines_gridService {
    if(!this._ds_transload_order_lines_grid) {
      this._ds_transload_order_lines_grid = this.injector.get(FootprintManager_ds_transload_order_lines_gridService);
    }
    return this._ds_transload_order_lines_grid;
  }
  private _ds_transload_order_receiving_grid: FootprintManager_ds_transload_order_receiving_gridService;
  public get ds_transload_order_receiving_grid(): FootprintManager_ds_transload_order_receiving_gridService {
    if(!this._ds_transload_order_receiving_grid) {
      this._ds_transload_order_receiving_grid = this.injector.get(FootprintManager_ds_transload_order_receiving_gridService);
    }
    return this._ds_transload_order_receiving_grid;
  }
  private _ds_transload_orders_grid: FootprintManager_ds_transload_orders_gridService;
  public get ds_transload_orders_grid(): FootprintManager_ds_transload_orders_gridService {
    if(!this._ds_transload_orders_grid) {
      this._ds_transload_orders_grid = this.injector.get(FootprintManager_ds_transload_orders_gridService);
    }
    return this._ds_transload_orders_grid;
  }
  private _ds_transload_outbound_shipments_grid: FootprintManager_ds_transload_outbound_shipments_gridService;
  public get ds_transload_outbound_shipments_grid(): FootprintManager_ds_transload_outbound_shipments_gridService {
    if(!this._ds_transload_outbound_shipments_grid) {
      this._ds_transload_outbound_shipments_grid = this.injector.get(FootprintManager_ds_transload_outbound_shipments_gridService);
    }
    return this._ds_transload_outbound_shipments_grid;
  }
  private _ds_transload_received_inventory_grid: FootprintManager_ds_transload_received_inventory_gridService;
  public get ds_transload_received_inventory_grid(): FootprintManager_ds_transload_received_inventory_gridService {
    if(!this._ds_transload_received_inventory_grid) {
      this._ds_transload_received_inventory_grid = this.injector.get(FootprintManager_ds_transload_received_inventory_gridService);
    }
    return this._ds_transload_received_inventory_grid;
  }
}

